export const GlobalEnum = [
    { name: 'YES', code: 'True' },
    { name: 'NO', code: 'False' },
]

export const InWard = [
    { name: 'InWard', code: 'True' },
    { name: 'OutWard', code: 'False' },    
]